export default __webpack_public_path__ + "static/media/m-tel.e31583cd.png";